import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

const quotesCarouselSwiper = document.querySelector('.quotes-carousel-swiper');

if (quotesCarouselSwiper) {
  new Swiper(quotesCarouselSwiper, {
    speed: 400,
    spaceBetween: 100,
    modules: [Navigation, A11y, Keyboard],
    navigation: {
      prevEl: '.quotes-carousel-swiper-button-prev',
      nextEl: '.quotes-carousel-swiper-button-next',
    },
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });
}
